/* ========================================
   TITLE: STICKY ATC JS (FINAL RESET)
   FILE: assets/sticky-atc.js
   PURPOSE: Sync sticky price + size dropdown with main PDP form
======================================== */

(function () {
  function initStickyAtc() {
    var stickyBars = document.querySelectorAll("[data-sticky-atc]");

    if (!stickyBars.length) return;

    stickyBars.forEach(function (bar) {
      if (bar.dataset.stickyAtcReady === "true") return;

      var priceEl = bar.querySelector("[data-sticky-atc-price]");
      var sizeSelect = bar.querySelector("[data-sticky-atc-size-select]");
      var buttonEl = bar.querySelector("[data-sticky-atc-button]");

      if (!priceEl || !buttonEl) return;

      function getMainProductForm() {
        return document.querySelector('form[action*="/cart/add"]');
      }

      function getVariantWrappers() {
        return document.querySelectorAll(".variant-wrapper");
      }

      function getMainSizeInputs() {
        var wrappers = getVariantWrappers();

        for (var i = 0; i < wrappers.length; i++) {
          var wrapper = wrappers[i];
          var label = wrapper.querySelector(".variant__label");

          if (!label) continue;

          var labelText = (label.textContent || "").trim().toLowerCase();

          if (labelText.indexOf("size") !== -1) {
            return {
              radios: wrapper.querySelectorAll('.variant-input input[type="radio"]'),
              select: wrapper.querySelector("select")
            };
          }
        }

        return null;
      }

      function getVisiblePriceText() {
        var selectors = [
          "[data-product-price]",
          ".product__price",
          ".product-single__price",
          ".price-item--sale",
          ".price-item--regular"
        ];

        for (var i = 0; i < selectors.length; i++) {
          var el = document.querySelector(selectors[i]);
          if (el && el.textContent.trim() !== "") {
            return el.textContent.trim();
          }
        }

        return priceEl.textContent.trim();
      }

      function getSelectedSize() {
        var sizeInputs = getMainSizeInputs();
        if (!sizeInputs) return "";

        if (sizeInputs.radios && sizeInputs.radios.length) {
          for (var i = 0; i < sizeInputs.radios.length; i++) {
            if (sizeInputs.radios[i].checked) {
              return sizeInputs.radios[i].value;
            }
          }
        }

        if (sizeInputs.select && sizeInputs.select.value) {
          return sizeInputs.select.value;
        }

        return "";
      }

      function syncPriceAndSize() {
        var visiblePrice = getVisiblePriceText();
        var selectedSize = getSelectedSize();

        if (visiblePrice) {
          priceEl.textContent = visiblePrice;
        }

        if (sizeSelect && selectedSize) {
          sizeSelect.value = selectedSize;
        }
      }

      function applyStickySizeToMainPicker() {
        if (!sizeSelect) return true;

        var chosen = sizeSelect.value;
        if (!chosen) return false;

        var sizeInputs = getMainSizeInputs();
        if (!sizeInputs) return false;

        if (sizeInputs.radios && sizeInputs.radios.length) {
          for (var i = 0; i < sizeInputs.radios.length; i++) {
            if (sizeInputs.radios[i].value === chosen) {
              sizeInputs.radios[i].checked = true;
              sizeInputs.radios[i].dispatchEvent(new Event("change", { bubbles: true }));
              return true;
            }
          }
        }

        if (sizeInputs.select) {
          sizeInputs.select.value = chosen;
          sizeInputs.select.dispatchEvent(new Event("change", { bubbles: true }));
          return true;
        }

        return false;
      }

      function triggerMainAddToCart() {
        var form = getMainProductForm();
        if (!form) return;

        var addButton =
          form.querySelector('button[name="add"]') ||
          form.querySelector(".product-form__cart-submit") ||
          form.querySelector(".btn--add-to-cart");

        if (addButton) {
          addButton.click();
        }
      }

      if (sizeSelect) {
        sizeSelect.addEventListener("change", function () {
          applyStickySizeToMainPicker();
        });
      }

      buttonEl.addEventListener("click", function (event) {
        event.preventDefault();

        if (sizeSelect && !sizeSelect.value) {
          sizeSelect.focus();
          return;
        }

        applyStickySizeToMainPicker();
        setTimeout(triggerMainAddToCart, 80);
      });

      document.addEventListener("change", function () {
        setTimeout(syncPriceAndSize, 60);
      });

      document.addEventListener("variant:change", function () {
        setTimeout(syncPriceAndSize, 60);
      });

      setTimeout(syncPriceAndSize, 250);

      bar.dataset.stickyAtcReady = "true";
    });
  }

  document.addEventListener("DOMContentLoaded", initStickyAtc);
  document.addEventListener("page:loaded", initStickyAtc);
  document.addEventListener("shopify:section:load", initStickyAtc);
})();